/**
 * Layout compartilhado entre todas as views do admin.
 * Header com brand + nav principal + botão de auth.
 */

import { getUsuarioLogado } from '../lib/auth.js';

export function escapeHtml(s: string): string {
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

/**
 * Renderiza o shell (header + main + footer) com o conteúdo HTML dentro do main.
 * O conteúdo é injetado raw — fica responsabilidade do caller escapar valores.
 */
export function renderLayout(opts: {
  title: string;
  bodyHtml: string;
  activeNav?: 'dashboard' | 'propostas' | 'precos';
}): string {
  const usuario = getUsuarioLogado();
  const nav = usuario
    ? `
      <a href="/" data-route class="nav-link${opts.activeNav === 'dashboard' ? ' nav-link-active' : ''}">Dashboard</a>
      <a href="/propostas" data-route class="nav-link${opts.activeNav === 'propostas' ? ' nav-link-active' : ''}">Propostas</a>
      <a href="/admin/precos" data-route class="nav-link${opts.activeNav === 'precos' ? ' nav-link-active' : ''}">Preços</a>
    `
    : '';

  const userActions = usuario
    ? `<span class="user">${escapeHtml(usuario.nome)}</span>
       <button type="button" class="btn btn-secondary btn-sm" data-action="sync-omie" title="Sincronizar catálogo do Omie agora">Sync Omie</button>
       <button type="button" class="btn btn-secondary" data-action="logout">Sair</button>`
    : `<button type="button" class="btn btn-primary" data-action="login">Entrar com Microsoft</button>`;

  document.title = `${opts.title} · Infomatic Propostas`;

  return `
    <header class="header no-print">
      <div class="container header-inner">
        <div class="brand">
          <a href="/" data-route style="color: inherit; text-decoration: none">
            <strong>Infomatic</strong> · Propostas
          </a>
        </div>
        <nav class="nav">
          ${nav}
          ${userActions}
        </nav>
      </div>
    </header>
    <main class="container" style="padding-top: var(--sp-8); padding-bottom: var(--sp-8); min-height: 60vh">
      ${opts.bodyHtml}
    </main>
    <footer class="footer no-print">
      <div class="container">
        <small style="color: var(--color-text-muted)">
          Infomatic Gestão em TI · Av. Presidente Kennedy, 166 — Indaiatuba, SP
        </small>
      </div>
    </footer>
  `;
}

/** Injeta CSS do header/nav/footer no <head> uma única vez. */
let stylesInjected = false;
export function injectLayoutStyles(): void {
  if (stylesInjected) return;
  stylesInjected = true;
  const styleEl = document.createElement('style');
  styleEl.textContent = `
    .header {
      background: var(--color-text);
      color: var(--color-surface);
      padding: var(--sp-4) 0;
    }
    .header-inner {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: var(--sp-4);
    }
    .brand { font-family: var(--font-display); font-size: var(--fs-lg); }
    .brand strong { color: var(--color-primary); }
    .nav { display: flex; gap: var(--sp-4); align-items: center; flex-wrap: wrap; }
    .nav-link {
      color: rgba(255,255,255,0.7);
      text-decoration: none;
      font-size: var(--fs-sm);
      padding: var(--sp-2) var(--sp-3);
      border-radius: 4px;
    }
    .nav-link:hover { color: var(--color-surface); }
    .nav-link-active {
      color: var(--color-primary);
      background: rgba(255,255,255,0.05);
    }
    .user { font-size: var(--fs-sm); color: rgba(255,255,255,0.7); }
    .btn-sm { font-size: var(--fs-xs); padding: var(--sp-1) var(--sp-3); }
    .footer { padding: var(--sp-6) 0; border-top: 1px solid var(--color-border); margin-top: var(--sp-8); }
  `;
  document.head.appendChild(styleEl);
}
